module.exports = __webpack_public_path__ + "img/face_shape_male_rect_mask.05f3a562.png";